import React, { Fragment } from 'react';
import { graphql } from 'gatsby';
import SVG from 'react-inlinesvg';
import Media from 'react-media';
import ScrollableAnchor, {configureAnchors} from 'react-scrollable-anchor';

import { connect } from 'react-redux';
import Layout from '../layouts/layout';
import ContactForm from '../components/contact-form/contactForm';

import { SelectInput, DropdownWrapper } from '../components/contact-form/styles';
import {
  Title,
} from '../styles/articles';

import {
  Container,
  ContactFormContainer,
  RegionalOfficesContainer,
  DistributionContainer,
  InnerDistributionContainer,
  Centers,
  DropdownOuter,
  Map,
  MapImage,
  RegionalSubOffices,
} from '../styles/contact';
import AddressTile from '../components/address-tile/address-tile';
import { extractAddress } from '../utils/selectors';
import { setCountry, setCountryList } from '../store/actions';

class Index extends React.Component {
  constructor(props) {
	super(props);
	
	configureAnchors({offset: -60, scrollDuration: 400, keepLastAnchorHash: true})

    const contact = props.data.allPrismicContact.edges[ 0 ].node.data;
    const viewMapLabel = contact.view_map_label.text;

    
    this.state = {
        pageInit: false,
        selectedCountry: 'na', //props.country.country_code.text,
        viewMapLabel,
    };
  }

  componentWillReceiveProps(nextProps, nextContext) {
    // console.log("Index -> componentWillReceiveProps -> pageInit", this.state.pageInit)
    // console.log("Index -> componentWillReceiveProps -> nextProps", nextProps)
    const {pageInit} = this.state;
    if(!pageInit){
        this.setState({pageInit: true});
        return;
    }

    this.setState({
      selectedCountry: nextProps.country.country_code.text,
    })
  }

  onDropDown = (event) => {
    // console.log(event.target.value);
    this.setState({ selectedCountry: event.target.value })
  }

  render() {
    const {
      data,
      countryList,
    } = this.props;

    const contact = data.allPrismicContact.edges[ 0 ].node.data;
    const regionalOffices = contact.body1[ 0 ].items.map(office => extractAddress(office));
    const distributionCenter = contact.body2[ 0 ].items.map(office => extractAddress(office));

    const {
      selectedCountry,
      viewMapLabel,
    } = this.state;

    // console.log("selectedCountry", selectedCountry);
    const filteredCenters = distributionCenter.filter(center => center.countryCode.toLowerCase() === selectedCountry.toLowerCase());

    return (
      <Layout isWhite>
		<Title>{ contact.heading.text }</Title>
		<Container>
			<ContactFormContainer>
				<h2>{ contact.get_in_touch_heading.text }</h2>
				<p>{ contact.contact_form_introduction.text }</p>
				<ContactForm />
			</ContactFormContainer>
			<RegionalOfficesContainer>
				<h2>{ contact.heading1.text }</h2>
				{
				regionalOffices.map((office, index) => index === 0 ? <AddressTile key = { office.name } viewMapText = { viewMapLabel } { ...office } /> : null)
				}
				
				<h2>{ contact.regional_heading.text }</h2>
				<RegionalSubOffices>
					{
					regionalOffices.map((office, index) => index > 0 ? <AddressTile key = { office.name } viewMapText = { viewMapLabel } { ...office } /> : null)
					}
				</RegionalSubOffices>
				
			</RegionalOfficesContainer>
		</Container>
        
		<ScrollableAnchor id={'distribution'}>
			<DistributionContainer>
			<InnerDistributionContainer>
				<h1>{ contact.heading2.text }</h1>
				<p>{ contact.introduction.text }</p>
				<DropdownOuter>
				<DropdownWrapper>
					<SelectInput
                        style = { { marginBottom: '20px' } }
                        onChange = { event => this.onDropDown(event) }  >
					{ countryList.map(country => <option key = { country.country_code.text } value = { country.country_code.text } >{ country.country.text }</option> ) }
					</SelectInput>
				</DropdownWrapper>
				</DropdownOuter>
				<Centers>
				{
					filteredCenters.map(office => <AddressTile key = { `${ office.name }${ office.street }` } isWhite { ...office } viewMapText = { viewMapLabel } />)
				}
				</Centers>
				<Media query = "(min-width: 768px)">
				<Map>
					<MapImage src="/images/worldmap2020.png" />
				</Map>
				</Media>
			</InnerDistributionContainer>
			</DistributionContainer>
		</ScrollableAnchor>
      </Layout>
    );
  }
}

export const query = graphql`
    {
        allPrismicContact {
            edges {
                node {
                    data {
                        heading {
                            text
                        }
                        get_in_touch_heading {
                            text
                        }
                        contact_form_introduction {
                            text
                        }
                        heading1 {
                            text
                        }
                        heading2 {
                            text
                        }
                        regional_heading {
                            text
                        }
                        introduction {
                            text
                        }
                        contact_form_name_placeholder {
                            text
                        }
                        contact_form_email_placeholder {
                            text
                        }
                        contact_form_company_placeholder {
                            text
                        }
                        contact_form_phone_number_placeholder {
                            text
                        }
                        contact_form_comments_placeholder {
                            text
                        }
                        contact_form_submit_label {
                            text
                        }
                        view_map_label {
                            text
                        }
                        
                        body1 {
                            items {
                                company_name {
                                    html
                                    text
                                }
                                street {
                                    html
                                    text
                                }
                                city {
                                    html
                                    text
                                }
                                country {
                                    html
                                    text
                                }
                                phone {
                                    html
                                    text
                                }
                                maps_link {
                                    link_type
                                    url
                                    target
                                }
                            }
                        }
                        body2 {
                            items {
                                company_name {
                                    text
                                }
                                street {
                                    text
                                }
                                zip {
                                    text
                                }
                                city {
                                    text
                                }
                                country {
                                    text
                                }
                                country_code {
                                    text
                                }
                                maps_link {
                                    url
                                }
                                website {
                                    url
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;

const mapStateToProps = state => ({
  country: state.country,
  countryList: state.countryList,
});

const mapDispatchToProps = dispatch => ({
  setCountry: country => dispatch(setCountry(country)),
  setCountryList: countryList => dispatch(setCountryList(countryList))
});

export default connect(mapStateToProps, mapDispatchToProps)(Index);
